import { tns } from "../../node_modules/tiny-slider/src/tiny-slider";

import { fslightbox } from "../../node_modules/fslightbox";

const sliders = [...document.getElementsByClassName('slider')];
sliders.forEach((slider) => {
    tns({
        container: slider,
        items: 1,
        slideBy: 'page',
        navPosition: 'bottom',
        mouseDrag: true,
        swipe: 30
    });
});

const mobileNavIcon = document.getElementById('mobile-menu-button');
const bodyElement = document.getElementsByTagName('body')[0];

const topLevelMenuItems = [...document.querySelectorAll('.navigation-primary > .navigation-item')];
const secondLevelMenuItems = [...document.querySelectorAll('.navigation-primary .navigation-sub > .navigation-item')];

const subMenuItemsArrowString = '<span class="arrow-decoration"><span></span></span>';

function initMobileMenu(){
    secondLevelMenuItems.forEach((menuItem) => {
        menuItem.innerHTML += subMenuItemsArrowString;
    });
    topLevelMenuItems.forEach((menuItem) => {
        menuItem.innerHTML += subMenuItemsArrowString;
    });

    const allArrows = [...document.querySelectorAll('.arrow-decoration')];
    allArrows.forEach((arrowItem) => {
        if(arrowItem.parentElement.classList.contains('navigation-section')) {
            arrowItem.classList.add('toggle-button', 'toggle-siblings');

            if (arrowItem.parentElement.classList.contains('active')) {
                toggleMobileMenuSiblings(arrowItem);
            }
        }

        if(arrowItem.parentElement.classList.contains('has-sub-children')) {
            arrowItem.classList.add('toggle-button', 'toggle-sub-children');

            if (arrowItem.parentElement.classList.contains('active')) {
                toggleMobileMenuSubChildren(arrowItem);
            }
        }
        if(arrowItem.parentElement.classList.contains('has-children')) {
            arrowItem.classList.add('toggle-button', 'toggle-children');

            if (arrowItem.parentElement.classList.contains('active')) {
                toggleMobileMenuChildren(arrowItem);
            }
        }
    });

    const siblingToggleButtons = [...document.getElementsByClassName('toggle-siblings')];
    siblingToggleButtons.forEach((siblingToggleButton) => {
        siblingToggleButton.addEventListener("click", function(e){
            e.preventDefault();
            toggleMobileMenuSiblings(e.target);
        });
    });

    const subchildToggleButtons = [...document.getElementsByClassName('toggle-sub-children')];
    subchildToggleButtons.forEach((childToggleButton) => {
        childToggleButton.addEventListener("click", function(e){
            e.preventDefault();
            toggleMobileMenuSubChildren(e.target);
        });
    });

    const childToggleButtons = [...document.getElementsByClassName('toggle-children')];
    childToggleButtons.forEach((childToggleButton) => {
        childToggleButton.addEventListener("click", function(e){
            e.preventDefault();
            toggleMobileMenuChildren(e.target);
        });
    });

    if(mobileNavIcon) {
        mobileNavIcon.addEventListener("click", function(e){
            e.preventDefault();
            toggleMobileMenu();
        });
}
}

function toggleMobileMenu() {
    if(!mobileNavIcon) {
        return;
    }

    if(mobileNavIcon.classList.contains("is-active"))
    {
        closeMobileMenu();
    }
    else
    {
        mobileNavIcon.classList.add("is-active");
        bodyElement.classList.add("nav-active");
    }
}

function closeMobileMenu() {
    if(!mobileNavIcon) {
        return;
    }
    
    if(mobileNavIcon.classList.contains("is-active"))
    {
        mobileNavIcon.classList.remove("is-active");
        bodyElement.classList.remove("nav-active");
    }
}

function toggleMobileMenuSubChildren(element) {
    if(element.closest(".has-sub-children").classList.contains("show-sub-children")){
        element.closest(".has-sub-children").classList.remove("show-sub-children")
    }
    else {
        hideAllShowingMenuSubChildren();
        element.closest(".has-sub-children").classList.add("show-sub-children")
    }
}

function toggleMobileMenuChildren(element) {
    if(element.closest(".has-children").classList.contains("show-children")){
        element.closest(".has-children").classList.remove("show-children")
    }
    else {
        hideAllShowingMenuChildren();
        element.closest(".has-children").classList.add("show-children")
    }
}

function hideAllShowingMenuSubChildren() {
    const showingChildrens = [...document.getElementsByClassName('show-sub-children')];
    showingChildrens.forEach((showingChildren) => {
        showingChildren.classList.remove("show-sub-children");
    });
}
function hideAllShowingMenuChildren() {
    const showingChildrens = [...document.getElementsByClassName('show-children')];
    showingChildrens.forEach((showingChildren) => {
        showingChildren.classList.remove("show-children");
    });
}

function toggleMobileMenuSiblings(element) {
    if (element.closest('.navigation-item').classList.contains('show-siblings')) {
        hideAllShowingMenuSiblings();
    } else {
        hideAllShowingMenuSiblings();

        const allSiblings = [...element.closest(".navigation-sub").getElementsByClassName('navigation-item')];
        let foundTrigger = false;

        let lastSibling = null;
        allSiblings.forEach((sibling) => {
            if (sibling.classList.contains('navigation-section')) {
                if (sibling === element.closest('.navigation-item')) {
                    sibling.classList.add('show-siblings');
                    foundTrigger = true;
                } else {
                    foundTrigger = false;

                    if (lastSibling) {
                        lastSibling.classList.add('last-sibling');
                    }
                }
            }
            if (foundTrigger) {
                sibling.classList.add('show-sibling');
            }
            lastSibling = sibling;
        });
        if (lastSibling) {
            lastSibling.classList.add('last-sibling');
        }
    }
}

function hideAllShowingMenuSiblings() {
    const showingSiblingsMain = [...document.getElementsByClassName('show-siblings')];
    showingSiblingsMain.forEach((showingSibling) => {
        showingSibling.classList.remove("show-siblings");
    });

    const showingSiblings = [...document.getElementsByClassName('show-sibling')];
    showingSiblings.forEach((showingSibling) => {
        showingSibling.classList.remove("show-sibling");
    });
}

initMobileMenu();
initNavigationAutoClose();

/* Collapse the expanded navigation. Covers the desktop sub-navigation panel (shown via
   :focus-within, so we drop focus), the mobile toggle panels (shown via classes added on
   tap) and the mobile overlay. */
function closeAllNavigation() {
    if (document.activeElement && typeof document.activeElement.blur === 'function') {
        document.activeElement.blur();
    }

    const openItems = [...document.querySelectorAll('.show-children, .show-sub-children, .show-siblings, .show-sibling')];
    openItems.forEach((item) => {
        item.classList.remove('show-children', 'show-sub-children', 'show-siblings', 'show-sibling');
    });

    closeMobileMenu();
}

/* The Login portal links open in a separate tab, so the navigation would otherwise stay
   expanded — sitting over the other menus — when the user returns to the site. Close it
   when a portal link is clicked, and again when the page is restored from the back/forward
   cache (which re-shows whatever state the page was left in). */
function initNavigationAutoClose() {
    const portalLinks = [...document.querySelectorAll('.navigation-login .navigation-sub .navigation-link')];
    portalLinks.forEach((link) => {
        link.addEventListener('click', closeAllNavigation);
    });

    window.addEventListener('pageshow', function(event) {
        if (event.persisted) {
            closeAllNavigation();
        }
    });
}

const headerWrapper = document.getElementById('header-ref');
document.addEventListener("DOMContentLoaded", function() {
    const scrollToElement = function(id) {
        const element = document.getElementById(id);

        if (element && headerWrapper) {
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.scrollY - (headerWrapper.getBoundingClientRect().height + 50);
            closeMobileMenu();
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        }
    };

    if (window.location.hash) {
        const id = window.location.hash.substring(1);
        scrollToElement(id);
    }

    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener("click", function(event) {
            event.preventDefault();
            const id = this.getAttribute("href").substring(1);
            history.pushState(null, null, `#${id}`);
            scrollToElement(id);
        });
    });
});